module.exports = __webpack_public_path__ + "img/Novalis.a8b35a91.png";